import { AbstractControl, Validators, ValidationErrors } from '@angular/forms';

export function phoneOrEmailValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  
  if (!value) {
    return { required: true };
  }

  // Check if it's a valid email
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (emailPattern.test(value)) {
    return null;
  }

  // Check if it's a valid phone number (10 digits)
  const phonePattern = /^\d{10}$/;
  if (phonePattern.test(value)) {
    return null;
  }

  // If neither email nor phone, return error
  return { invalidPhoneOrEmail: true };
}